import fetchLicenses from "@api/operations/fetch-licenses";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { NextSeo } from "next-seo";
import React from "react";

import Container from "@components/Container";
import Gifts from "@components/Gifts";
import MainLayout from "@components/MainLayout";

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const {
    cookies: { token },
  } = req;
  const { page = 0, size = 10 } = query;

  const result = await fetchLicenses(token, parseInt(page as string), parseInt(size as string));

  return {
    props: {
      page: result.page,
    },
  };
};

export default function MyGiftsPage({ page }: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Container>
      <NextSeo title="My Gifts | Mount Olive Family Medicine Center Online Training" />
      <Gifts page={page} />
    </Container>
  );
}

MyGiftsPage.Layout = MainLayout;
